module.exports = __webpack_public_path__ + "static/img/spring_jianjiePic.6c631ff8.png";